const MainKeys = require("../enums/MainKey");
const MainAssessmentKeys = require("../enums/MainAssessmentKey");
const {
  STATUS_NUMBER_TO_TEXT,
  DEFAULT_STATUS,
  getStatusText,
} = require("../enums/Status");
const {
  REASON_CODE_NUMBER_TO_TEXT,
  DEFAULT_REASON_CODE,
  getReasonCodeText,
} = require("../enums/ReasonCode");
const { isValidTimezone } = require("../utilities/timezone");

/**
 * Generates the main object
 * @param {Object} imageIndexDatabaseInfo Database info for an image (image_index table)
 * @returns {Object} Main object
 */
const generateMain = (imageIndexDatabaseInfo) => {
  let {
    image_id,
    date_taken_milliseconds,
    date_posted_milliseconds,
    date_modified_milliseconds,
    user_timezone,
    status,
    reason_code,
  } = imageIndexDatabaseInfo;
  // Default the status and reason code if they are not valid
  if (!(status in STATUS_NUMBER_TO_TEXT)) {
    status = DEFAULT_STATUS;
  }

  if (!(reason_code in REASON_CODE_NUMBER_TO_TEXT)) {
    reason_code = DEFAULT_REASON_CODE;
  }

  // Verify image_id, user_timezone are strings
  if (typeof image_id !== "string") {
    throw new Error("image_id must be a string");
  }

  if (typeof user_timezone !== "string") {
    throw new Error("user_timezone must be a string");
  }

  // Verify that user_timezone is a valid timezone
  if (!isValidTimezone(user_timezone)) {
    throw new Error("user_timezone is not a valid timezone");
  }

  // Verify date_taken_milliseconds, date_posted_milliseconds, date_modified_milliseconds are numbers
  if (typeof date_taken_milliseconds !== "number") {
    throw new Error("date_taken_milliseconds must be a number");
  }
  if (typeof date_posted_milliseconds !== "number") {
    throw new Error("date_posted_milliseconds must be a number");
  }
  if (typeof date_modified_milliseconds !== "number") {
    throw new Error("date_modified_milliseconds must be a number");
  }

  // Verify status, reason_code are numbers
  if (typeof status !== "number") {
    throw new Error("status must be a number");
  }
  if (typeof reason_code !== "number") {
    throw new Error("reason_code must be a number");
  }

  return {
    [MainKeys.IMAGE_ID]: image_id,
    [MainKeys.DATE_TAKEN_MILLISECONDS]: date_taken_milliseconds,
    [MainKeys.DATE_POSTED_MILLISECONDS]: date_posted_milliseconds,
    [MainKeys.DATE_MODIFIED_MILLISECONDS]: date_modified_milliseconds,
    [MainKeys.USER_TIMEZONE]: user_timezone,
    [MainKeys.ASSESSMENT]: {
      [MainAssessmentKeys.STATUS_NUMBER]: status,
      [MainAssessmentKeys.STATUS_TEXT]: getStatusText(status),
      [MainAssessmentKeys.REASON_CODE_NUMBER]: reason_code,
      [MainAssessmentKeys.REASON_CODE_TEXT]: getReasonCodeText(reason_code),
    },
  };
};

module.exports = {
  generateMain,
};
